import { shallowMount, config, createLocalVue } from '@vue/test-utils';
import SupportCtas from './SupportCtas';

describe('SupportCtas', () => {
  let localVue;
  config.mocks['MRConfig'] = {
    contactPhone: '1-123-456-6789'
  };

  beforeEach(()=> {
    localVue = createLocalVue();

  });
 
  describe('default', ()=> {
    test('display elements "email", "chat", and "phone"', () => {
      const wrapper = shallowMount(SupportCtas, { localVue });

      expect(wrapper.contains('.icon-email')).toBe(true);

      expect(wrapper.contains('.icon-chat')).toBe(true);

      expect(wrapper.contains('.icon-phone')).toBe(true);
    });

  });

  describe('customize via props', ()=> {
    test('display elements "chat" and "phone" but not "email"', () => {
      const hideCtas = ['email'];
      const wrapper = shallowMount(SupportCtas, { localVue, propsData: { hideCtas } });

      expect(wrapper.contains('.icon-email')).toBe(false);

      expect(wrapper.contains('.icon-chat')).toBe(true);

      expect(wrapper.contains('.icon-phone')).toBe(true);
    });

    test('link a new phone number', () => {
      const phoneNumber = '1-cus-tom-ized';
      const hideCtas = ['email', 'chat'];
      const wrapper = shallowMount(SupportCtas, { localVue, propsData: { phoneNumber, hideCtas } });

      expect(wrapper.find('.support-cta').attributes('href')).toBe(`tel:${phoneNumber}`);

    });
  });

});
